import React from "react";
import styles from "./styles.module.scss";
import Button from "app/components/Button/ButtonVariant";
import InvitationsList from "../../InvitationsList";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Invitations = () => {
  const history = useHistory();

  const { t } = useTranslation();

  const route = (path: string) => {
    history.push(path);
  };

  const NullResult = () => {
    return (
      <div className={styles.empty_container}>
        <p className={styles.empty_text}>{t("No invitations")}</p>
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <InvitationsList nullResultChildren={<NullResult />} />
      <div className={styles.footer}>
        <Button
          title={t("View All")}
          buttonStyles={styles.read_all_btn}
          buttonType="secondary-outline"
          onClickFunc={() => route("/activity/invitations")}
        />
      </div>
    </div>
  );
};

export default Invitations;
